/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.megadodo.MegadodoSeverity
*/
export var MegadodoSeverity;
(function (MegadodoSeverity) {
    MegadodoSeverity["INFO"] = "INFO";
    MegadodoSeverity["WARN"] = "WARN";
    MegadodoSeverity["ERROR"] = "ERROR";
})(MegadodoSeverity || (MegadodoSeverity = {}));
//# sourceMappingURL=MegadodoSeverity.js.map